// extracted by mini-css-extract-plugin
module.exports = {"race-details":"Item_race-details__2M5ek","active":"Item_active__CH8uX","race-name":"Item_race-name__FKTIu","link":"Item_link__2szTI","summary":"Item_summary__2KE77"};